<h4 class="f-w-700">{{title}}</h4>
<nav>
    <ol class="breadcrumb justify-content-sm-start align-items-center mb-0">
        <li class="breadcrumb-item">
            <a [routerLink]="['/superadmin/dashboard']" aria-label="Dashboard">
                <app-feather-icons [icons]="'home'"></app-feather-icons>
            </a>
        </li>

        @if (breadcrumbs.parentBreadcrumb) {
        <li class="breadcrumb-item f-w-400">
            <a *ngIf="breadcrumbs.parentLink" [routerLink]="[breadcrumbs.parentLink]">
                {{ breadcrumbs.parentBreadcrumb }}
            </a>
            <span *ngIf="!breadcrumbs.parentLink">{{ breadcrumbs.parentBreadcrumb }}</span>
        </li>
        }

        @if (breadcrumbs.childBreadcrumb) {
        <li class="breadcrumb-item f-w-400 active">{{breadcrumbs.childBreadcrumb}}</li>
        }
    </ol>
</nav>